import { addToDebugData } from '@wix/package-picker-shared';
import { extractTitleFromDealerOffers } from '../dealer.utils';
export const getDealerTitleQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const {
    placementId,
    siteId,
    siteAuthorizationType
  } = request;
  const {
    DealerApiClient
  } = await import('../dealer.api-client');
  const {
    listOffers
  } = DealerApiClient.queries({
    httpClient
  });
  const offers = await listOffers({
    placementId,
    siteId,
    siteAuthorizationType
  });
  addToDebugData({
    dealerTitle: {
      offers,
      request
    }
  });
  return {
    title: extractTitleFromDealerOffers(offers)
  };
};
//# sourceMappingURL=getDealerTitle.query.js.map